<template>
    <v-dialog
        :value="isOpen"
        max-width="1100px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Historia statusu
                </h1>
            </v-card-title>

            <v-card-text>
                <v-data-table
                    :headers="complaintHistoryHeaders"
                    :items="complaintStatusHistory"
                    hide-default-footer
                    disable-pagination
                    :mobile-breakpoint="0"
                    name="complaintHistoryData"
                >
                    <template #item="{item}">
                        <tr>
                            <td class="text-center">
                                {{ item.oldStatus.name }}
                            </td>
                            <td class="text-center">
                                {{ item.newStatus.name }}
                            </td>
                            <td class="text-center">
                                <template v-if="item.changer.firstName && item.changer.lastName">
                                    {{ item.changer.firstName }} {{ item.changer.lastName }}
                                </template>
                                <template v-else>
                                    {{ item.changer.username }}
                                </template>
                            </td>
                            <td class="text-center">
                                {{ formatDate(item.createdAt) }}
                            </td>
                        </tr>
                    </template>

                    <template slot="no-results" :value="true">
                        <p class="text-center">
                            Brak danych
                        </p>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onAbort"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'StatusHistoryDialog',
    mixins: [
        dateFormatter,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        complaintStatusHistory: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            complaintHistoryHeaders: [
                {
                    text: 'Status przed',
                    value: 'oldStatus',
                    sortable: false,
                    align: 'center',
                    width: 180
                },
                {
                    text: 'Status po',
                    align: 'center',
                    sortable: false,
                    value: 'newStatus',
                },
                {
                    text: 'Zmieniający',
                    align: 'center',
                    sortable: false,
                    value: 'changer'
                },
                {
                    text: 'Data utworzenia',
                    align: 'center',
                    sortable: false,
                    value: 'createdAt'
                }
            ]
        }
    },
    methods: {
        onAbort() {
            this.$emit('close-status-history-dialog')
        },
    }
}
</script>